<template>
  <a-layout class="ehf-layout-wrap">
    <a-layout-content class="story-manage-layout-content">
      <div class="content">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script setup>
  import { onBeforeUnmount, onMounted } from 'vue'
  import { useStore } from 'vuex'
  const store = useStore()
  const WIDTH = 1024

  const isMobile = () => {
    const rect = document.body.getBoundingClientRect()
    return rect.width < WIDTH
  }

  const resizeHandler = () => {
    if (!document.hidden) {
      store.dispatch('settings/toggleDevice', isMobile() ? 'mobile' : 'desktop')

      if (isMobile()) {
        store.dispatch('settings/closeSideBar')
      }
    }
  }
  onMounted(() => {
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeHandler)
  })
</script>

<style lang="scss" scoped>
  .story-manage-layout-content {
    min-height: 100vh !important;
    padding: 0;
    margin: 0;
  }
</style>
